/* Florelle: cart-drawer upgrade button + keep free e-book gifts in sync with pouch quantity. */
(function () {
  var busy = false;
  function state() { return document.getElementById('fl-upsell-state'); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.renderContents === 'function') d.renderContents({ id: null, sections: sections });
    });
  }
  function giftIdsFor(qty) {
    // gift variant ids in unlock order, read from the page render (data-expected-gifts is only for current qty),
    // so we use a static list mirrored from the theme snippet.
    var all = (window.FL_GIFT_IDS || []);
    var n = qty >= 5 ? 5 : qty >= 3 ? 3 : qty === 2 ? 2 : 0;
    return all.slice(0, n);
  }
  // Make cart = N pouches + the correct gifts for N.
  function syncTo(mainId, qty, onlyGifts) {
    busy = true;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) {
        var isGift = it.properties && it.properties._free_gift;
        if (isGift || (!onlyGifts && it.variant_id == mainId)) updates[it.key] = 0;
      });
      return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      var items = [];
      if (!onlyGifts && qty > 0) items.push({ id: mainId, quantity: qty });
      giftIdsFor(qty).forEach(function (gid) {
        items.push({ id: gid, quantity: 1, properties: { _free_gift: 'true', Delivery: 'Download link sent after your order is confirmed' } });
      });
      return items.length ? post('/cart/add.js', { items: items }) : null;
    }).then(refreshDrawer).finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fl-upgrade]');
    if (!btn) return;
    e.preventDefault();
    var s = state(); if (!s || busy) return;
    btn.disabled = true; btn.textContent = 'Upgrading…';
    syncTo(parseInt(s.dataset.mainId), parseInt(btn.dataset.flUpgrade), false);
  });

  // When shoppers change pouch qty / remove items in the drawer, fix the gift lines.
  var t;
  function check() {
    if (busy) return;
    var s = state(); if (!s) return;
    var qty = parseInt(s.dataset.qty || '0');
    var expected = giftIdsFor(qty).map(String).sort().join(',');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var actual = cart.items.filter(function (it) { return it.properties && it.properties._free_gift; })
        .map(function (it) { return String(it.variant_id); }).sort().join(',');
      var realQty = cart.items.filter(function (it) { return it.variant_id == s.dataset.mainId; })
        .reduce(function (a, it) { return a + it.quantity; }, 0);
      if (realQty !== qty) return; // drawer not yet re-rendered; next mutation will re-check
      if (expected !== actual && !busy) syncTo(parseInt(s.dataset.mainId), qty, true);
    });
  }
  new MutationObserver(function (muts) {
    if (!muts.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.id === 'fl-upsell-state' || (n.querySelector && n.querySelector('#fl-upsell-state'))); }); })) return;
    clearTimeout(t); t = setTimeout(check, 400);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
